// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2hd3V","header":"ReportDetails_header__J_AsV","title":"ReportDetails_title__16uPB","left":"ReportDetails_left__3L01z"};